// extracted by mini-css-extract-plugin
export default {"lens-ui-font-definition":"nVkvsCOZCsQSWGn1ag4Z","lensUiFontDefinition":"nVkvsCOZCsQSWGn1ag4Z","modal-footer":"AJTkgETdlql2_IAG0XsL","modalFooter":"AJTkgETdlql2_IAG0XsL"};